import { ComponentConfig } from "@measured/puck";
import styles from "./styles.module.css";
import getClassNameFactory from "@/lib/get-class-name-factory";
import { DropZone } from "@measured/puck";
import { Section } from "../../components/Section";
import { withLayout } from "../../components/Layout";

const getClassName = getClassNameFactory("Grid", styles);

export type GridProps = {
  numColumns: number;
  gap: number;
};

const sizeOptions = [
  { value: 1, label: "1" },
  { value: 2, label: "2" },
  { value: 3, label: "3" },
  { value: 4, label: "4" },
];

export const GridInternal: ComponentConfig<GridProps> = {
  fields: {
    numColumns: {
      type: "select",
      label: "Number of columns",
      options: sizeOptions,
    },
    gap: {
      label: "Gap",
      type: "number",
      min: 0,
    },
  },
  defaultProps: {
    numColumns: 4,
    gap: 12,
  },
  render: ({ gap, numColumns }) => {
    return (
      <Section>
        <DropZone
          zone="grid"
          disallow={[]}
          className={`${getClassName()} ${
            [
              "grid-cols-1",
              "grid-cols-2",
              "grid-cols-2 xl:grid-cols-3",
              "grid-cols-2 xl:grid-cols-4",
            ][(numColumns - 1) % 4]
          }`}
          style={{
            gap,
          }}
        ></DropZone>
      </Section>
    );
  },
};

export const Grid = withLayout(GridInternal);
